import React from 'react';
import './CircleProgressbarReport.scss';
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar';

const CircleProgressbarReport = ({data}) => {

  try {
    return (
      <section className='progressbar_monitoring'>

        <div className='progressbar_conatiner'>
          {data?.map((item, index) =>
            <div className='circular_progressbar_content' key={"f" + index}>
              <div className='circular_progressbar'>
                <div style={{position: "absolute"}}>
                  <CircularProgressbar
                    value={item?.value}
                    strokeWidth={14}
                    text={""}
                    styles={buildStyles({
                      rotation: 0.25,
                      pathTransitionDuration: 0.5,
                      pathColor: item?.color,
                      backgroundColor: '#F1F1F1',
                      trailColor: '#F1F1F1',
                    })}
                  />
                </div>
                <p className='circular_progressbar_amount iransans-b'>{item?.value}%</p>
              </div>
              <h3 className='circular_progressbar_title iransans'>{item?.title}</h3>
              <div className='status_container'>
                <div className='status' style={{marginBottom: '4px'}}>
                  <div className='status_square' style={{backgroundColor: '#F1F1F1'}}></div>
                  <span className='status_text iransans-b'>خیر</span>
                </div>
                <div className='status'>
                  <div className='status_square' style={{backgroundColor: item?.color}}></div>
                  <span className='status_text iransans-b'>بله</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default CircleProgressbarReport;